export async function saveToCache(cacheName: string, url: string, data: unknown) {
    if (typeof caches === 'undefined') return;
    try {
        const cache = await caches.open(cacheName);
        await cache.put(url, new Response(JSON.stringify(data)));
    } catch (err) {
        console.warn('[CacheUtils] Failed to save to cache:', err);
    }
}

export async function readFromCache<ItemType>(cacheName: string, url: string): Promise<ItemType | undefined> {
    if (typeof caches === 'undefined') return undefined;
    try {
        const cache = await caches.open(cacheName);
        const response = await cache.match(new Request(url));
        return await response?.json();
    } catch (err) {
        return undefined;
    }
}

export async function deleteFromCache(cacheName: string, url: string) {
    if (typeof caches === 'undefined') return;
    try {
        const cache = await caches.open(cacheName);
        await cache.delete(url);
    } catch (err) {
    }
}

export async function clearAllCacheEntries(cacheName: string) {
    if (typeof caches === 'undefined') return;
    try {
        const cache = await caches.open(cacheName);
        const keys = await cache.keys();
        await Promise.all(keys.map(key => cache.delete(key)));
    } catch (err) {
        console.warn(`[CacheUtils] Failed to clear cache: ${cacheName}`, err);
    }
}